export const UPDATE_CHANNELS = ["stable", "beta", "next", "none"];
